export { contactsEnrichCommand } from './contacts_enrich';
export { contactsDiscoverCommand } from './contacts_discover';

import { contactsEnrichCommand } from './contacts_enrich';
import { contactsDiscoverCommand } from './contacts_discover';

export const contactsCommands = [
  contactsEnrichCommand,
  contactsDiscoverCommand,
];
